import { render, staticRenderFns } from "./HjPhoneField.vue?vue&type=template&id=2aa0f5e6&scoped=true&"
import script from "./HjPhoneField.vue?vue&type=script&lang=js&"
export * from "./HjPhoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0f5e6",
  null
  
)

export default component.exports